import dynamic from 'next/dynamic'

import { Stack } from '@mui/material'
import { useWallet } from '@renec-foundation/wallet-adapter-react'

import useAmplitude from '@/hooks/use-amplitude'
import useTrans from '@/hooks/useTrans'

import { EVENT_NAMES } from '@/constants/amplitude'
import WalletBalances from '@/wallet/ui/WalletBalances'

const WalletMultiButtonDynamic = dynamic(
  // async () => (await import('@solana/wallet-adapter-react-ui')).WalletMultiButton,
  async () => (await import('@renec-foundation/wallet-adapter-react')).WalletMultiButton,
  { ssr: false },
)

const ConnectWallet = () => {
  const amplitude = useAmplitude()
  const trans = useTrans()
  const { publicKey } = useWallet()

  return (
    <Stack
      onClick={() => {
        if (!publicKey) {
          amplitude.track(EVENT_NAMES.page_connect_wallet_on_header)
        }
      }}
    >
      <WalletMultiButtonDynamic className="btn-border-gradient h-[36px] rounded-[100px] px-4 py-2 text-sm normal-case">
        {!publicKey ? <span className="wallet-adapter-button-content">{trans.common.connect_wallet}</span> : null}
      </WalletMultiButtonDynamic>
      <WalletBalances />
    </Stack>
  )
}

export default ConnectWallet
